import { type WizardStepErrors } from '@synqo/frontend-component-library';
import { type ContainerPosition, hasContent } from '../../containerOrder';

export type DetailsStepErrorKey = 'positions' | 'content';

/**
 * What the step says when "Weiter" does not go on.
 *
 * Only the empty step needs saying here: a missing content stands at the content field. The message
 * goes as soon as there is a position, rather than waiting for the next "Weiter" — the wizard
 * refreshes its own errors only then.
 */
export function blockingDetailsError(
    errors: WizardStepErrors<DetailsStepErrorKey>,
    position: ContainerPosition | undefined,
): string | undefined {
    return position ? undefined : errors.positions;
}

/** What the content field says when "Weiter" does not go on; gone as soon as a content is chosen. */
// @ai-generated 2026-10-22T16:29:04+00:00 by niklas.eicker@tngtech.com using Claude Opus 5.5 (1M context)
export function contentError(
    errors: WizardStepErrors<DetailsStepErrorKey>,
    position: ContainerPosition | undefined,
): string | undefined {
    return position && !hasContent(position) ? errors.content : undefined;
}

/** A step with one container goes on once there is one, and it says what is in it. */
// @ai-generated 2026-10-09T08:04:13+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function validateDetails(
    position: ContainerPosition | undefined,
    missingPosition: string,
    missingContent: string,
): WizardStepErrors<DetailsStepErrorKey> {
    if (!position) {
        return { positions: missingPosition };
    }

    return hasContent(position) ? {} : { content: missingContent };
}
